<template>
  <table
    ref="table"
    class="c-table c-table--region"
    :class="[classes ? classes : '']"
  >
    <thead>
      <tr>
        <th class="c-table__cell--center u-w54"></th>
        <th class="c-table__cell--center is-sortable">
          <span class="c-table__text">地域</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'id' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'id' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'id') }"
          ></span>
        </th>
        <th class="c-table__cell--center u-w160 is-sortable">
          <span class="c-table__text">配信対象数</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'delivery' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'delivery' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'delivery') }"
          ></span>
        </th>
        <th class="c-table__cell--center u-w160 is-sortable">
          <span class="c-table__text">インプレッション</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'impression' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'impression' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'impression') }"
          ></span>
        </th>
        <th class="c-table__cell--center u-w160 is-sortable">
          <span class="c-table__text">クリック数</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'click' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'click' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'click') }"
          ></span>
        </th>
        <th class="c-table__cell--center u-w160 is-sortable">
          <span class="c-table__text">クリック率(%)</span>
          <span
            class="c-btn c-btn--sort"
            :class="[
              {'c-btn--sort-asc': sort.key == 'ctr' && sort.type == 'asc'},
              {'c-btn--sort-desc': sort.key == 'ctr' && sort.type == 'desc'},
            ]"
            @click="(e) => { updateSort(e, 'ctr') }"
          ></span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="index of 8" :key="index">
        <td class="c-table__cell--center c-table__cell--middle">{{ index }}</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import * as d3 from 'd3';

export default {
  props: {
    classes: { type: String, required: false },
    onSortClick: { type: Function, required: true },
  },
  data() {
    return {
      chartElements: {
        table: null,
      },
      columns: {},
      data: null,
      period: {},
      sort: {},
      tooltipData: {
        prefectureId: '',
      },
    }
  },

  mounted: function() {
    this.chartElements.table = d3.select(this.$refs.table);
  },

  methods: {
    init: function(data, period, sort) {
      // 日付、データ、ソート指定を保存
      this.period = period;
      this.sort = sort;

      // 地域別サマリーを取得
      const regionSummary = this.getRegionSummary(data, this.sort)

      // フォーマッター設定
      const numberFormatter = new Intl.NumberFormat('ja-JP', {
        setMaximumFractionDigits: 1,
      });
      const percentFormatter = new Intl.NumberFormat('ja-JP', {
        style: 'percent',
        maximumFractionDigits: 2,
      });

      // 地域別配信数テーブル更新
      this.chartElements.table
        .selectAll('tbody tr')
        .each((d, i, nodes) => {
          const summary = regionSummary[i].value;

          // 表示用データ作成
          const displayData = {
            region: summary.region,
            delivery: numberFormatter.format(summary.delivery),
            impression: numberFormatter.format(summary.impression),
            click: numberFormatter.format(summary.click),
            ctr: Number(percentFormatter.format(summary.ctr).replace(',', '').replace('%', '')).toFixed(2),
          }

          // プロパティ値には、実数値を設定
          d3.select(nodes[i])
            .property('region', summary.region)
            .property('click', summary.click)
            .property('ctr', summary.ctr)
            .property('delivery', summary.delivery)
            .property('impression', summary.impression);

          nodes[i].children[1].textContent = displayData.region;
          nodes[i].children[2].textContent = displayData.delivery;
          nodes[i].children[3].textContent = displayData.impression;
          nodes[i].children[4].textContent = displayData.click;
          nodes[i].children[5].textContent = displayData.ctr;
        })
    },

    getRegionSummary: function(data, sort) {
      // 地域別の合計数を作成
      let regionSummary = {
        Hokkaido: { id: 1, region: '北海道', delivery: 0, impression: 0, click: 0, ctr: 0 },
        Tohoku: {id: 2, region: '東北', delivery: 0, impression: 0, click: 0, ctr: 0 },
        Kanto: {id: 3, region: '関東', delivery: 0, impression: 0, click: 0, ctr: 0 },
        Chubu: {id: 4, region: '中部', delivery: 0, impression: 0, click: 0, ctr: 0 },
        Kinki: {id: 5, region: '近畿', delivery: 0, impression: 0, click: 0, ctr: 0 },
        Chugoku: {id: 6, region: '中国', delivery: 0, impression: 0, click: 0, ctr: 0 },
        Shikoku: {id: 7, region: '四国', delivery: 0, impression: 0, click: 0, ctr: 0 },
        Kyushu: {id: 8, region: '九州・沖縄', delivery: 0, impression: 0, click: 0, ctr: 0 },
      }

      // 都道府県IDの指標値を地域別に合算
      data.items.forEach((item) => {
        const values = {
          delivery: (item.delivery) ? item.delivery : 0,
          impression: (item.impression) ? item.impression : 0,
          click: (item.click) ? item.click : 0,
        };

        if (item.prefectureId <= 1) {
          regionSummary.Hokkaido.delivery += values.delivery;
          regionSummary.Hokkaido.impression += values.impression;
          regionSummary.Hokkaido.click += values.click;
        }
        if (2 <= item.prefectureId && item.prefectureId <= 7) {
          regionSummary.Tohoku.delivery += values.delivery;
          regionSummary.Tohoku.impression += values.impression;
          regionSummary.Tohoku.click += values.click;
        }
        if (8 <= item.prefectureId && item.prefectureId <= 14) {
          regionSummary.Kanto.delivery += values.delivery;
          regionSummary.Kanto.impression += values.impression;
          regionSummary.Kanto.click += values.click;
        }
        if (15 <= item.prefectureId && item.prefectureId <= 23) {
          regionSummary.Chubu.delivery += values.delivery;
          regionSummary.Chubu.impression += values.impression;
          regionSummary.Chubu.click += values.click;
        }
        if (24 <= item.prefectureId && item.prefectureId <= 30) {
          regionSummary.Kinki.delivery += values.delivery;
          regionSummary.Kinki.impression += values.impression;
          regionSummary.Kinki.click += values.click;
        }
        if (31 <= item.prefectureId && item.prefectureId <= 35) {
          regionSummary.Chugoku.delivery += values.delivery;
          regionSummary.Chugoku.impression += values.impression;
          regionSummary.Chugoku.click += values.click;
        }
        if (36 <= item.prefectureId && item.prefectureId <= 39) {
          regionSummary.Shikoku.delivery += values.delivery;
          regionSummary.Shikoku.impression += values.impression;
          regionSummary.Shikoku.click += values.click;
        }
        if (40 <= item.prefectureId) {
          regionSummary.Kyushu.delivery += values.delivery;
          regionSummary.Kyushu.impression += values.impression;
          regionSummary.Kyushu.click += values.click;
        }
      });

      // 指標値の合計値から、CTRを再計算
      // @Todo 母数はimpression（インプレッション）で問題ないか？を念のため確認
      regionSummary.Hokkaido.ctr = (regionSummary.Hokkaido.click > 0 && regionSummary.Hokkaido.impression > 0) ? regionSummary.Hokkaido.click / regionSummary.Hokkaido.impression : 0;
      regionSummary.Tohoku.ctr = (regionSummary.Tohoku.click > 0 && regionSummary.Tohoku.impression > 0) ? regionSummary.Tohoku.click / regionSummary.Tohoku.impression : 0;
      regionSummary.Kanto.ctr = (regionSummary.Kanto.click > 0 && regionSummary.Kanto.impression > 0) ? regionSummary.Kanto.click / regionSummary.Kanto.impression : 0;
      regionSummary.Chubu.ctr = (regionSummary.Chubu.click > 0 && regionSummary.Chubu.impression > 0) ? regionSummary.Chubu.click / regionSummary.Chubu.impression : 0;
      regionSummary.Kinki.ctr = (regionSummary.Kinki.click > 0 && regionSummary.Kinki.impression > 0) ? regionSummary.Kinki.click / regionSummary.Kinki.impression : 0;
      regionSummary.Chugoku.ctr = (regionSummary.Chugoku.click > 0 && regionSummary.Chugoku.impression > 0) ? regionSummary.Chugoku.click / regionSummary.Chugoku.impression : 0;
      regionSummary.Shikoku.ctr = (regionSummary.Shikoku.click > 0 && regionSummary.Shikoku.impression > 0) ? regionSummary.Shikoku.click / regionSummary.Shikoku.impression : 0;
      regionSummary.Kyushu.ctr = (regionSummary.Kyushu.click > 0 && regionSummary.Kyushu.impression > 0) ? regionSummary.Kyushu.click / regionSummary.Kyushu.impression : 0;

      // 指標値の降順で集計配列をソート
      regionSummary = Object.keys(regionSummary).map((key) => {
        return { key, value: regionSummary[key] };
      })

      regionSummary.sort((a, b) => {
        if (sort.type.toLowerCase() == 'desc') {
          if (a.value[sort.key] < b.value[sort.key]) return 1;
          if (a.value[sort.key] > b.value[sort.key]) return -1;
          return 0;
        } else {
          if (a.value[sort.key] > b.value[sort.key]) return 1;
          if (a.value[sort.key] < b.value[sort.key]) return -1;
          return 0;
        }
      })

      return regionSummary;
    },

    updateSort: function(e, key) {
      // クリックしたソートボタンの状態で昇順・皇潤を判定 && ソートボタンの表示を切り替え
      if (e.target.classList.contains('c-btn--sort-desc')) {
        this.sort.key = key;
        this.sort.type = 'asc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-asc');
      } else {
        this.sort.key = key;
        this.sort.type = 'desc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-desc');
      }
      this.onSortClick(this.sort);
    },
  },
}
</script>
